import React from 'react'
import { Dropdown } from 'react-bootstrap'

import { KTIcon } from '../../../../../../_metronic/helpers'
import { RowKebabMenu } from '../../../../../common/RowKebabMenu'

interface Props {
  hasPricing: boolean
  expanded: boolean
  onToggleExpand: () => void
}

// Меню действий строки операции — общая «⋮» (RowKebabMenu, тот же паттерн, что
// и в ActivePaymentTicketRowMenu). Единственное действие сейчас — детали
// ценообразования, поэтому меню не рендерится, если их нет (CPAYMENT-1739 QA).
export const OperationRowMenu: React.FC<Props> = ({ hasPricing, expanded, onToggleExpand }) => {
  if (!hasPricing) return null

  return (
    <RowKebabMenu title='Действия по операции'>
      <Dropdown.Item
        as='button'
        type='button'
        className='d-flex align-items-center'
        onClick={onToggleExpand}
      >
        <KTIcon iconName='notepad-bookmark' className='fs-3 me-2' />
        {expanded ? 'Скрыть детали' : 'Детали операции'}
      </Dropdown.Item>
    </RowKebabMenu>
  )
}

export default OperationRowMenu
